module.exports = __webpack_public_path__ + "a2fe79463864c9b5b24d997ffa7dd443.png";